import hash from 'object-hash';
import { BaseApi } from '@/main/baseApi';
import { EditPageModule, editStateBuilder } from '@/main/store/pages/edit/builder';
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { UPDATE_BASIC_EDIT, CREATE, UPDATE, UPDATE_EDIT_HASH } from '@/main/store/listEditTypes';
import { dataMapper } from '@/main/utils/dataMapper';
import _ from 'lodash';
import { convertToObjects, Table } from '@/main/utils/table';
import { writeAction } from '@/main/store/actionsFunctions';
import { Status } from '@/main/store/@types/page';
import { EditStore, DepTables } from '@/main/store/@types/edit.d';
import { RootStore } from '@/main/store/@types/store.d';
import { ActionTree, MutationTree, GetterTree } from 'vuex';

import { POLOZKY } from '../constants';

export interface CheckboxItem {
	Acces: boolean,
	Text: string,
	VybCheckbox: boolean,
	ZvlnabidkaOzn: string,
}

const zalohy = 	{
	name: '',
	crumbLabel: '',
	dropdownList: {
		ZakzalohaPzn: [] as DropdownItem[],
		PovzalohaPzn: [] as DropdownItem[],
	},
	edit: {
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		EditPracIdText: null as string | null,
		PenalePrp: null as boolean | null,
		ProvozovnaId: null as number | null,
		ProvozovnaIdText: null as string | null,
		PrvniDdDat: null as Date | null,
		UzavreniDat: null as Date | null,
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		VyrazenDat: null as Date | null,
	},
	depTableNames: [POLOZKY],
	depTableSettings: {
		[POLOZKY]: {
			loadByEntityId: true,
			isEditable: true,
			columns: {
				ZAZNAM_ID: { isEditable: false },
				ZAKZALOHA_PZN: { isEditable: true, required: true },
				POVZALOHA_PZN: { isEditable: true, required: true },
				CASTKA: { isEditable: true, align: 'right', type: 'number', required: true },
				TEXT: { isEditable: true, required: true },
				ZAKZALOHA_ID: { isEditable: false },
				UpdateStatus: { isEditable: false },
			},
			filter(state:ZalohyState) {
				return { id: state.props.id };
			},
		},
	},
	localState: {
	},
	props: {
		mode: null,
		id: undefined,
		filter: {
			ZakaznikIdText: null as string | null,
			VozidloText: null as string | null,
		},
	},
};

export const zalohyState = editStateBuilder(zalohy);

export type ZalohyState = EditStore<typeof zalohy.edit, typeof zalohy.dropdownList,
	typeof zalohy.localState, DepTables<typeof zalohy.depTableNames>, typeof zalohy.props>;

export type ZalohyStoreModule = EditPageModule<ZalohyState, {}, {}, {}>;

type EditComponentModule = {
	extraActions: ActionTree<ZalohyState, RootStore>;
	extraMutations: MutationTree<ZalohyState>,
	extraGetters: GetterTree<ZalohyState, RootStore>,
} & typeof zalohy;

export function zalohyStoreBuilder(apiProvider: BaseApi): EditComponentModule {
	return {
		...zalohy,
		extraActions: {
			[CREATE](
				{ state, commit, dispatch },
				{ goBack }: { goBack: boolean },
			) {
				return writeAction(
					state,
					commit,
					dispatch,
					apiProvider!.createEntity({
						...state.edit,
						Polozky: convertToObjects({ rows: state.dependentTables.Polozky.rows, columns: state.dependentTables.Polozky.columns }),
					}),
					goBack,
				);
			},

			/**
				 * Generates an action that creates a request to update an entity on backend,
				 * if goBack then calls `router.back()`.
				 *
				 * Uses the {@link writeAction} helper function.
				 *
				 * @returns this.
				 */
			[UPDATE](
				{ state, commit, dispatch },
				{ id, goBack }: { id: string | number, goBack: boolean },
			) {
				return writeAction(
					state,
					commit,
					dispatch,
					apiProvider!.updateEntity(id, {
						...state.edit,
						Polozky: convertToObjects({ rows: state.dependentTables.Polozky.rows, columns: state.dependentTables.Polozky.columns }),
					}),
					goBack,
				);
			},
		},
		extraGetters: {},
		extraMutations: {
			[UPDATE_BASIC_EDIT](state, { data }: { data: any }) {
				data.DropDownList && (state.dropdownList = { ...(state.dropdownList ?? {}), ...data.DropDownList });
				delete data.DropDownList;
				data.Operations && (state.operations = data.Operations);
				delete data.Operations;
				if (data.ValidationRules) {
					if (!_.isEmpty(data.ValidationRules)) {
						state.validationRules = data.ValidationRules;
					}
					const table: Table = state.dependentTables.Polozky;
					table.columnSettings!.ZAKZALOHA_PZN = { ...table.columnSettings!.ZAKZALOHA_PZN, ...data.ValidationRules.ZakzalohaPzn };
					table.columnSettings!.POVZALOHA_PZN = { ...table.columnSettings!.POVZALOHA_PZN, ...data.ValidationRules.PovzalohaPzn };
					table.columnSettings!.CASTKA = { ...table.columnSettings!.CASTKA, ...data.ValidationRules.Castka };
					table.columnSettings!.TEXT = { ...table.columnSettings!.TEXT, ...data.ValidationRules.Text };
					delete data.ValidationRules;
				}
				dataMapper(state.edit, data);
			},
			[UPDATE_EDIT_HASH](state) {
				state.editHash = hash(state.edit);
				state.status = Status.ok;
			},
		},
	};
}
